import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Moma Design Studio
 * id B17B3489-56A4-490D-828E-61A64754EB1A
 * name umbrella-closed-variant
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/umbrella-closed-variant.svg
 * tags
 * - Weather 
 */
export const UmbrellaClosedVariantIcon = createSvgIcon(<><path d="M15 7L13 6V3.5C13 3.2 13.2 3 13.5 3S14 3.2 14 3.5V4H16V3.5C16 2.1 14.9 1 13.5 1S11 2.1 11 3.5V6L9 7L6 6L11.1 21.3C11.4 22.2 12.7 22.2 13 21.3C14.6 16.2 18 6 18 6L15 7M11 15L9 8.9L9.7 9.1L11 8.1V15M13 8.1L14.3 9.1L15 8.9L13 15V8.1Z" /></>, 'UmbrellaClosedVariantIcon');
export default UmbrellaClosedVariantIcon